import { render, staticRenderFns } from "./wadi-al-safa.vue?vue&type=template&id=3f36feed&"
import script from "./wadi-al-safa.vue?vue&type=script&lang=js&"
export * from "./wadi-al-safa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports